import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';
import { Loader2, Lock } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) {
        setError('Invalid credentials');
        return;
      }
      const data = await res.json();
      localStorage.setItem('admin_token', data.token);
      navigate('/admin');
    } catch {
      setError('Connection error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-gray-800 bg-gray-900">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="text-gray-900" size={24} />
            </div>
            <h1 className="text-2xl font-bold text-white" data-testid="admin-login-title">Admin Portal</h1>
            <p className="text-gray-400 text-sm mt-1">Revs Vibes Management</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1.5">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-gray-800 border-gray-700 text-white"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1.5">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-gray-800 border-gray-700 text-white"
                data-testid="admin-login-password"
              />
            </div>
            {error && <p className="text-red-400 text-sm" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" className="w-full bg-white text-black hover:bg-gray-200" disabled={loading} data-testid="admin-login-submit">
              {loading && <Loader2 className="animate-spin mr-2" size={16} />}
              Sign In
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
